import { styled } from "@mui/material/styles";
import { Grid, Box } from "@mui/material";
import { Button } from "Components/Form";

export const UserProfileSectionTitle = styled("div")(() => ({
  fontFamily: "Manrope",
  fontWeight: 500,
  fontSize: "10px",
  color: "#98A2B3",
  textTransform: "uppercase",
  marginBottom: "4px",
}));

export const GridItemContainer = styled(Grid)(() => ({
  display: "flex",
  flexDirection: "column",
  flex: 1,
  minHeight: 0,
  overflow: "hidden",
}));

export const CompanyMenuListContainer = styled(Box, {
  shouldForwardProp(propName) {
    return propName !== "scroll";
  },
})<{ scroll: boolean }>(({ scroll }) => ({
  flex: 1,
  minHeight: 0,
  overflowY: scroll ? "auto" : "hidden",
  padding: "0 10px 8px 0",
  display: "flex",
  flexDirection: "column",
  gap: "10px",
}));

export const Divider = styled("hr")(() => ({
  margin: "7px 0",
}));

export const SwitchCompanyOption = styled(Button)(() => ({
  padding: "0 !important",
}));
